<template>
    <account-container :title="stageTitle">
      <p>If you have previously submitted a claim or saved an in progress claim form then we will have sent you an email
      with your login details.  If you have forgotten your password the please <router-link :to="{ name: 'resetpassword'}" class="reset-link" replace>request a new password</router-link>.</p>
        
      <div class="form-group">
        <label for="username">Username / Email</label>
        <input type="text" 
              id="username" 
              fieldlabel="Username"
              v-model="username"
              v-taurus-validator="'required'"
              class="form-control form-control-lg">
        <div class="" name="username" invalidfeedback="Please enter username / email address"></div>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" 
              id="password" 
              fieldlabel="Password"
              v-model="password"
              v-taurus-validator="'required'"
              class="form-control form-control-lg">
        <div class="" name="password" invalidfeedback="Please enter your password"></div>
      </div>
        <transition name="fade">
            <form-alert :show="failure == true" :flavour="2" :resellerId="77">Login failed please try again.</form-alert>
        </transition>
        <button class="button account-section-bottom-button" style="margin-right: 0.5rem;" @click="handleSubmit()">Login</button>
        <router-link class="account-section-bottom-rest-link" :to="{ name: 'resetpassword'}" replace>Forgotten password?</router-link>
    </account-container>
</template>

<script>

import base from '@/mixins/base'
import AccountContainer from '@/components/AccountContainer.vue'
import FormAlert from '@/components/FormAlert.vue'
export default {
  name: 'login',
  components: {
    AccountContainer,
    FormAlert
  },
  mixins: [
    base
  ],
  data () {
    return {
      username: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.authentication.status.loggingIn
    },
    failure () {
      return this.$store.state.authentication.status.failure
    },
    returnurl () {
      return this.$route.query.returnurl
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  created () {
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    handleSubmit (e) {
      if (this.checkForm()) {
        this.submitted = true
        const { resellerId, username, password, returnurl } = this
        const { dispatch } = this.$store
        if (username && password) {
          dispatch('authentication/login', { resellerId, username, password, returnurl })
        }
      }
    }
  }
}
</script>
